'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerDemographics = function CustomerDemographics() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.USER_ATTRIBUTES_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = CustomerDemographics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/CustomerDemographics.js
// module id = 400
// module chunks = 3 4 5